import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

import global from '../../../styles/layout.module.scss';

import styles from './FaqsLayout.module.scss';

function FaqsLayout({ faqCategories }) {
  return (
    <section className={global.section}>
      <div className={global.container}>
        {faqCategories.map(c => (
          <div className={styles.row} key={c.uuid}>
            <h1 className={styles.title}>{c.title}</h1>
            <Accordion>
              {c.fields.questions.map(q => (
                <AccordionItem key={q.question}>
                  <AccordionItemHeading>
                    <AccordionItemButton>{q.question}</AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel dangerouslySetInnerHTML={{ __html: q.answer }} />
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        ))}
      </div>
    </section>
  );
}

FaqsLayout.propTypes = {
  faqCategories: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      questions: PropTypes.arrayOf(
        PropTypes.shape({
          question: PropTypes.string.isRequired,
          answer: PropTypes.string.isRequired,
        })
      ),
    })
  ),
};

FaqsLayout.defaultProps = {
  faqCategories: [],
};

export default FaqsLayout;
